import { Component, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";

import { MainConfig } from "@atenea-cms";
import { Department, DepartmentService } from "../shared";

@Component({
  selector: "department-list",
  templateUrl: "./department-list.component.html",
  styleUrls: ["./department-list.component.scss"],
  host: { class: "atn-list-crud" },
})
export class DepartmentListComponent implements OnInit {
  constructor(
    private titleService: Title,
    private mainConfig: MainConfig,
    public dataService: DepartmentService
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Departamentos - " + this.mainConfig.cmsName);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/departments/department-list/department-list.component.ts